import { createGlobalStyle, css } from 'styled-components';

import colors from './colors';

export const StyledGlobalCss = css`
  --blue: ${colors.teal50};
  --yellow-bright: ${colors.yellow15};
  --logo-orange: ${colors.logoOrange};
  --orange: ${colors.orange};
  --blue-grey: ${colors.blueGrey};
  --grey: ${colors.blueGrey75};
  --bluey-grey: ${colors.blueGrey};
  --light-blue-grey: ${colors.blueGrey25}
  --very-light-blue: ${colors.blueGrey10};
  --black: ${colors.darkGrey};
  --dark-grey: ${colors.darkGrey75};
  --blue-grey-two: ${colors.darkGrey50};
  --light-blue-grey-two: ${colors.darkGrey25};
  --disabled-grey: ${colors.darkGrey10};
  --error-red: ${colors.red};
  --visited-text-link: ${colors.teal};
  --success-green: ${colors.green};
  --text-link: ${colors.brown};
  --white: ${colors.white};

  @font-face {
    font-family: VIC;
    src: local(VIC-Regular),
    url(${props => props.theme.baseURL}/fonts/VIC-Regular.woff2) format('woff2'),
    url(${props => props.theme.baseURL}/fonts/VIC-Regular.woff) format('woff'),
    url(${props => props.theme.baseURL}/fonts/VIC-Regular.ttf) format('truetype');
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
  }

  @font-face {
    font-family: VIC;
    src: local(VIC-Medium),
    url(${props => props.theme.baseURL}/fonts/VIC-Medium.woff2) format('woff2'),
    url(${props => props.theme.baseURL}/fonts/VIC-Medium.woff) format('woff'),
    url(${props => props.theme.baseURL}/fonts/VIC-Medium.ttf) format('truetype');
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
  }

  @font-face {
    font-family: VIC;
    src: local(VIC-SemiBold),
    url(${props => props.theme.baseURL}/fonts/VIC-SemiBold.woff2) format('woff2'),
    url(${props => props.theme.baseURL}/fonts/VIC-SemiBold.woff) format('woff'),
    url(${props => props.theme.baseURL}/fonts/VIC-SemiBold.ttf) format('truetype');
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
  }

  @font-face {
    font-family: VIC;
    src: local(VIC-Bold),
    url(${props => props.theme.baseURL}/fonts/VIC-Bold.woff2) format('woff2'),
    url(${props => props.theme.baseURL}/fonts/VIC-Bold.woff) format('woff'),
    url(${props => props.theme.baseURL}/fonts/VIC-Bold.ttf) format('truetype');
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
  }

  html {
    height: 100%;
  }

  body {
    margin: 0;
    height: 100%;
  }

  #root {
    font-family: VIC,Verdana,Helvetica,sans-serif;
    font-smooth: always;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    height: 100%;
    background-color: ${colors.blueGrey10};
  }

  .ReactModal__Body--open {
    overflow: hidden;
  }
`;
/**
 * Generate a global StyledComponent that handles global styles (place it at the top React tree and the global styles will be injected when the components are "rendered")
 */
export const GlobalStyles = createGlobalStyle`${StyledGlobalCss}`;
export default GlobalStyles;
